import classnames from 'classnames';
import React from 'react';

import { IconFrame } from 'src/app/components/Icon/IconFrame';

interface MyProps {
  icon: JSX.Element;
  className?: string;
  classNameIcon?: string;
  position?: 'right';
}

export class IconContent extends React.Component<MyProps> {
  render(): JSX.Element {
    return (
      <span className={classnames('d-flex ai-center lh-1', this.props.className)}>
        {this.content}
      </span>
    );
  }

  private get content(): JSX.Element {
    const { children, classNameIcon, icon, position } = this.props;
    return position === 'right'
      ? <>{children} <IconFrame className={classnames('ml-6', classNameIcon)}>{icon}</IconFrame></>
      : <><IconFrame className={classnames('mr-6', classNameIcon)}>{icon}</IconFrame> {children}</>;
  }
}
